import { useRef } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import styles from "./RemoveAllModal.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Modal } from "shared/Modal";

/**
 *
 * Modal used for removing members on the members tab of the groups page.
 */

export function RemoveAllModal({ isOpen, onClose, onClick, ibos }) {
  const ref = useRef(); // We will use React useRef hook to reference the wrapping div:
  const { events } = useDraggable(ref); // Now we pass the reference to the useDraggable hook:

  return (
    <div className={classNames(styles.overlay, !isOpen && styles.hide)}>
      <div className={styles.container}>
        <div className={styles.title}>REMOVE ALL NON-LOS MEMBERS</div>

        <div className={styles.description}>
          Are you sure you would like to remove the following members from this
          group?
        </div>

        <div className={styles.listContainer}>
          <div className={styles.header}>
            <div>IBO Name</div>
            <div>IBO #</div>
          </div>

          <div className={styles.dragger} {...events} ref={ref}>
            {ibos.map((item, index) => (
              <div
                className={
                  index % 2 === 0
                    ? styles.backgroundWhite
                    : styles.backgroundGray
                }
                key={index}
              >
                <div className={styles.itemContainer}>
                  <div className={styles.item}>{item.iboName}</div>
                  <div className={styles.item}>{item.iboNum}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.buttonContainer}>
          <button
            className={classNames(styles.button, styles.cancelBtn)}
            onClick={onClose}
          >
            CANCEL
          </button>
          <button className={styles.button} onClick={onClick}>
            REMOVE ALL
          </button>
        </div>
      </div>
    </div>
  );
}

RemoveAllModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  ibos: PropTypes.arrayOf(PropTypes.object),
};
